'use client'

import { useEffect, useState } from 'react'

import { isSessionExpired, Logger } from '@rewardops/utils'

import { signOut } from './client-signout'
import { useSession } from './use-session'
import { useTenant } from './use-tenant'

interface SessionGuardProps {
  redirectUrl?: string
}

const SessionGuard = ({ redirectUrl }: SessionGuardProps) => {
  const { data: session, isLoading } = useSession()
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null)
  const tenant = useTenant()

  useEffect(() => {
    if (!isLoading && session) {
      if (timer) {
        clearInterval(timer)
      }

      setTimer(
        setInterval(() => {
          if (isSessionExpired(session)) {
            Logger.warn('Session expired, redirecting...')
            signOut({ redirectUrl, logoutEndpoint: tenant?.logoutEndpoint })
          }
        }, 1000),
      )
    }
    return () => {
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [isLoading, session])
  return null
}

export { SessionGuard }
